import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from './icon/Icon';
import { TranslatedCopy } from '../intl/TranslatedCopy';

import { debounce } from '../util/debounce';

class BackToTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: 0,
      isVisible: false
    };
  }

  componentDidMount() {
    const { delay } = this.props;
    window.addEventListener('scroll', debounce(this.onWindowScroll, delay));
  }

  componentWillUnmount() {
    this.unsetIntervalId();
  }

  setIntervalId = intervalId => this.setState({ intervalId });

  unsetIntervalId = () => {
    const { intervalId } = this.state;
    if (intervalId !== 0) {
      clearInterval(intervalId);
    }
    this.setState({ intervalId: 0 });
  };

  onWindowScroll = () => {
    const { startShowing } = this.props;
    const { isVisible: stateIsVisible } = this.state;
    const currScrollTop = window.pageYOffset;
    const isVisible = currScrollTop > startShowing;

    if (isVisible !== stateIsVisible) {
      this.setState({ isVisible });
    }
  };

  scrollStep = () => {
    const { scrollStep } = this.props;
    const { intervalId } = this.state;
    if (window.pageYOffset === 0) {
      clearInterval(intervalId);
      this.unsetIntervalId();
    }
    window.scroll(0, window.pageYOffset - scrollStep);
  };

  scrollToTop = () => {
    const { delay } = this.props;
    const { intervalId } = this.state;
    if (intervalId === 0) {
      const intervalId = setInterval(this.scrollStep.bind(this), delay);
      this.setIntervalId(intervalId);
    }
  };

  render() {
    const { isVisible } = this.state;
    const backToTopText = new TranslatedCopy({ id: 'global.button.backToTop' }).toString();

    return (
      <button
        title={backToTopText}
        type='button'
        aria-label={backToTopText}
        className={classnames('backToTop bg-black', { isVisible: isVisible })}
        onClick={this.scrollToTop}
        data-desc='backToTop__button'
        data-testid='back_to_top'
      >
        <Icon name='arrow-up' isLight alt={`${backToTopText} icon`} />
      </button>
    );
  }
}

BackToTop.propTypes = {
  delay: PropTypes.number,
  scrollStep: PropTypes.number,
  startShowing: PropTypes.number
};

BackToTop.defaultProps = {
  delay: 0,
  scrollStep: 100,
  startShowing: 400
};

export default BackToTop;
